import React from 'react';
import PropTypes from 'prop-types';

import StatsCard from './StatsCard';
import Row from '../common/Row/Row';

import './ClaimsStatsOverview.scss';
import { featureToggled } from '../../utils/featureToggle';

function ClaimsStatsOverview(props) {
  const { claimsStats = {} } = props;
  const { openCount, actionRequiredCount, acceptedAndAwaitingPaymentCount, draftCount } = claimsStats;

  const isFeatureFlagEnabled = featureToggled('claim-drafts-enabled');
  const size = isFeatureFlagEnabled ? 'skinny' : '';

  return (
    <div styleName="container">
      <Row spacing={20}>
        <StatsCard size={size} value={openCount}>
          Total open
        </StatsCard>
        {isFeatureFlagEnabled && (
          <StatsCard size={size} value={draftCount} intent="warning">
            Draft Claims
          </StatsCard>
        )}
        <StatsCard size={size} value={actionRequiredCount} intent="warning">
          Action required
        </StatsCard>
        <StatsCard size={size} value={acceptedAndAwaitingPaymentCount} intent="positive" isLast>
          Accepted & awaiting payment
        </StatsCard>
      </Row>
    </div>
  );
}

ClaimsStatsOverview.propTypes = {
  claimsStats: PropTypes.object,
};

export default ClaimsStatsOverview;
